//#region src/core/ui/controls/data.ts
const ControlsDataAttrs = {
	/** Present when controls are visible. */
	visible: "data-visible",
	/** Present when the user has recently interacted. */
	userActive: "data-user-active"
};
//#endregion
export { ControlsDataAttrs };

//# sourceMappingURL=data.js.map